var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSingle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 13.6654C3.31816 13.6654 0.333496 10.6807 0.333496 6.9987C0.333496 3.3167 3.31816 0.332031 7.00016 0.332031C10.6822 0.332031 13.6668 3.3167 13.6668 6.9987C13.6668 10.6807 10.6822 13.6654 7.00016 13.6654ZM7.00016 12.332C8.41465 12.332 9.7712 11.7701 10.7714 10.7699C11.7716 9.76974 12.3335 8.41319 12.3335 6.9987C12.3335 5.58421 11.7716 4.22766 10.7714 3.22746C9.7712 2.22727 8.41465 1.66536 7.00016 1.66536C5.58567 1.66536 4.22912 2.22727 3.22893 3.22746C2.22873 4.22766 1.66683 5.58421 1.66683 6.9987C1.66683 8.41319 2.22873 9.76974 3.22893 10.7699C4.22912 11.7701 5.58567 12.332 7.00016 12.332ZM7.00016 10.332C6.11611 10.332 5.26826 9.98084 4.64314 9.35572C4.01802 8.7306 3.66683 7.88275 3.66683 6.9987C3.66683 6.11464 4.01802 5.2668 4.64314 4.64167C5.26826 4.01655 6.11611 3.66536 7.00016 3.66536C7.88422 3.66536 8.73206 4.01655 9.35718 4.64167C9.98231 5.2668 10.3335 6.11464 10.3335 6.9987C10.3335 7.88275 9.98231 8.7306 9.35718 9.35572C8.73206 9.98084 7.88422 10.332 7.00016 10.332Z",
    fill: "#797F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle);
export default __webpack_public_path__ + "static/media/single.d1a856bee4c68ced33713eb6a31df4c8.svg";
export { ForwardRef as ReactComponent };